import Pusher from 'pusher-js';
import * as Cookies from "js-cookie";

export default {
  data() {
    return {
      appKey: process.env.VUE_APP_PUSHER_APP_KEY,
      cluster:  process.env.VUE_APP_PUSHER_APP_CLUSTER,
      authEndpoint: `${document.location.protocol}//${process.env.VUE_APP_API_HOST}/api/broadcasting/auth`,
      pusher: null,
    }
  },
  computed: {
    token() {
      return Cookies.getJSON("token");
    },
  },
  mounted() {
    this.pusher = new Pusher(this.appKey, {
      cluster: this.cluster,
      encrypted: true,
      authEndpoint: this.authEndpoint,
      auth: {
        headers: {Authorization : `Bearer ${this.token.access_token}`}
      }
    })

    this.pusher.logToConsole = true;

    let channel = this.pusher.subscribe(`private-system-notification-${this.token.user.id}`);

    channel.bind('system-notification-created', (data) => {
      this.afterSystemNotificationCreated(data.system_notification);
    });
  },
  beforeDestroy() {
    this.disconnect();
  },
  methods: {
    afterSystemNotificationCreated(newNotification) {
      return;
    },
    disconnect() {
      if (this.pusher !== null)
        this.pusher.disconnect();
    },
  },
}